export interface ISymbolsConfig {
    [symName: string]: {
        states: WalkOfShameSymbolState[];
        highSymbol?: boolean; // For which layer this symbol will be added.
        isSpecial?: boolean; // For is the symbol can be used for fill up the reel randomly.
    };
}

export enum WalkOfShameSymbolState {
    NORMAL = "normal",
    SPIN = "spin",
    SPIN_DIM = "spinDim",
    ANTICIPATION = "anticipation",
    WIN = "win",
    NO_WIN = "noWin",
    FULL = "full",
    EMPTY = "empty",
    LANDING = "landing"
}

export class WalkOfShameSymbolConfig {

    public static SYMBOLS_DEFAULT_STATES: WalkOfShameSymbolState[] = [
        WalkOfShameSymbolState.NORMAL,
        WalkOfShameSymbolState.SPIN,
        WalkOfShameSymbolState.WIN,
        WalkOfShameSymbolState.NO_WIN
    ];

    public static SYMBOLS: ISymbolsConfig = {
        "L1": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L2": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L3": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L4": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L5": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "M1": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "M2": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "M3": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "M4": {states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "S": {
            states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial: true,
            highSymbol: true
        },
        "S2": {
            states: WalkOfShameSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial: true,
            highSymbol: true
        }
    };
}